import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledButton = styled(Button)(({ theme }) => ({
  width: '52px',
  height: '52px',
  minWidth: '50px',
  borderRadius: '50%',
  position: 'sticky',
  float: 'right',
  bottom: '20px',
  margin: '-26px -26px 20px 0',
  border: `2px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: '#FAFCFF',
  fontWeight: '600',
  fontSize: '16px',
  lineHeight: '20px',
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
  },
  '& span': {
    fontSize: '32px',
  },
}));
